import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import MobileApps from 'public/images/landing/mobile-cta.png';
import LogoAppStore from 'public/images/logo/logo-app-store.png';
import LogoGooglePlay from 'public/images/logo/logo-google-play.png';
import ParallaxImage from 'components/ParallaxImage';

export default function FooterCtaMobileApp() {
  const { t } = useTranslation();

  return (
    <div className='max-w-1280 w-full mx-auto -mb-250 ipad:-mb-200 mt-40 ipad:mt-250 px-20 desktopSmall:px-40'>
      <div className='bg-primary-darker relative rounded-xl'>
        {/* bg parallax */}
        <div className='absolute overflow-hidden h-full w-full rounded-xl'>
          <ParallaxImage verticalStart='-55%' verticalEnd='25%'>
            <div className='w-250 h-250 rounded-full bg-[#1C4851] absolute -left-100' />
          </ParallaxImage>
          <ParallaxImage verticalStart='-75%' verticalEnd='5%'>
            <div className='w-250 h-250 rounded-full bg-[#566B70] absolute left-64' />
          </ParallaxImage>
        </div>
        
        <div className='flex flex-col ipad:flex-row justify-between relative z-10'>
          <div className='basis-8/12 p-20 ipad:p-52'>
            <p className='mt-0 ipad:mt-32'>
              <span className='text-white block text-title3 ipad:text-subtitle2 mb-4 font-medium'>{t('FindApplyJobs')}</span>
              <span className='text-green-lime italic block text-title3 ipad:text-subtitle2 font-medium'>{t('AnytimeAnywhere')}</span>
            </p>
            <p className='text-grey font-light mt-20'>{t('ApplyAndTrackJobs')}</p>
            <div className='flex gap-12 ipad:gap-20 mt-32'>
              <a
                href="https://apps.apple.com/id/app/onboard-crew-app/id6504788993"
                target='_blank'
                className='transition-all duration-300 hover:shadow-xl hover:-translate-y-4'
              >
                <Image src={LogoAppStore} alt="logo2" height={35} width={150} className='border border-grey-dark rounded' />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.onboard.android"
                target='_blank'
                className='transition-all duration-300 hover:shadow-xl hover:-translate-y-4'
              >
                <Image src={LogoGooglePlay} alt="logo2" height={35} width={150} className='border border-grey-dark rounded' />
              </a>
            </div>
          </div>
          <div className='basis-4/12 relative ipad:bg-transparent pb-[70%] ipad:pb-0 rounded-t-lg'>
            <div className='w-1/2 pb-[65%] ipad:pb-[129%] ipad:w-full absolute bottom-0 right-0 ipad:right-72 left-0 ipad:left-auto mx-auto'>
              <Image
                src={MobileApps.src}
                alt='OnBoard Company Feature'
                placeholder="blur"
                fill
                blurDataURL={MobileApps.blurDataURL}
                className='absolute'
                style={{ objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};
